import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type PlanogramState = {
  dateRange: {
    start: Date | null;
    end: Date | null;
  };
};

const initialState = (): PlanogramState => ({
  dateRange: {
    start: null,
    end: null,
  },
});

export const planogramSlice = createSlice({
  name: "planogram",
  initialState,
  reducers: {
    setPlanogramDateRange(
      state,
      action: PayloadAction<PlanogramState["dateRange"]>
    ) {
      state.dateRange = action.payload;
    },
  },
});

export const { setPlanogramDateRange } = planogramSlice.actions;
